module.exports = __webpack_public_path__ + "static/media/Justin-Chan.0b01fb4d.jpg";